import { lazy, Suspense } from "react";
import { Loading } from "../../elements/Loading";

// Lazy so the router and the delivery modal aren't loaded behind every record page.
const Card = lazy(() => import("./AutomationDeliveryCard"));

export function AutomationDeliveryCard() {
  return (
    <Suspense fallback={<Loading />}>
      <Card />
    </Suspense>
  );
}
